import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 自定义列hooks
 * @author alfielv
 */
import React, { useMemo } from 'react';
import _ from 'lodash';
import CustomColumn from './CustomColumn';
// 默认已选配置项结构
var INITIAL_SELECTED_DATA = {
  unmovableCells: [],
  fixed: [],
  unfixed: []
};
;
export default (function (props) {
  var configureDataSource = props.configureDataSource,
      columnsDefs = props.columnsDefs,
      _props$defaultSelecte = props.defaultSelectedColumns,
      defaultSelectedColumns = _props$defaultSelecte === void 0 ? INITIAL_SELECTED_DATA : _props$defaultSelecte;

  var fetchLoading = configureDataSource.fetchLoading,
      configureProps = _objectWithoutProperties(configureDataSource, ["fetchLoading"]); // 自定义列组件


  var customColumnComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(CustomColumn, {
      configureProps: configureProps,
      defaultColumns: defaultSelectedColumns,
      columnsDefs: columnsDefs
    });
  }, [columnsDefs, defaultSelectedColumns, configureProps]); // 已选列

  var selectedColumns = useMemo(function () {
    var activeConfigureName = configureProps.activeConfigureName,
        originConfigureList = configureProps.originConfigureList,
        localConfigure = configureProps.localConfigure;

    var retSelectConfigure = function () {
      // 远程
      if (!!activeConfigureName && activeConfigureName !== 'SESSION_STORAGE') {
        var originConfigure = _.find(originConfigureList, {
          name: activeConfigureName
        });

        return originConfigure || defaultSelectedColumns;
      } // 本地


      if (activeConfigureName === 'SESSION_STORAGE') {
        return localConfigure || defaultSelectedColumns;
      }

      return defaultSelectedColumns;
    }();

    return _objectSpread(_objectSpread({}, retSelectConfigure), !(_.isArray(retSelectConfigure.unmovableCells) && retSelectConfigure.unmovableCells.length > 0) && {
      unmovableCells: defaultSelectedColumns.unmovableCells
    });
  }, [configureProps, defaultSelectedColumns]);
  return {
    loading: fetchLoading,
    selectedColumns: selectedColumns,
    customColumnComponent: customColumnComponent
  };
});